export enum LayerListPanelAnalyticsEvent {
  LayerFilter = 'Layer Filter',
  LayerToggle = 'Layer Toggle',
  LayerEdit = 'Layer Edit',
  LayerView = 'Layer View',
  LayerDelete = 'Layer Delete',
  LayerSelectFromContextMenu = 'Layer Select From Context Menu',
  LayerDeselectFromContextMenu = 'Layer Deselect From Context Menu',
  LayerIsolateFromContextMenu = 'Layer Isolate From Context Menu',
  LayerUnisolateFromContextMenu = 'Layer Unisolate From Context Menu',
}
